function Banner() {
 return(
  <div className='relative'>
    <div className='absolute top-1/4 left-[35%]'>
      <h2 className='text-center font-semibold text-5xl'>
        Welcome to Mak Electronic
      </h2>
      <p className='text-center'>Get 20% off on apple products</p>
    </div>
    <img src={require('../../assets/images/banner/2.jpg')} className="w-full object-cover object-center" />
  </div>
 )
}

export default Banner;
